import { useSelector } from 'react-redux'
import styles from '../SuperAdminDashboard.module.scss'

export function AdminVendorStatsCard() {
	const vendorStats = useSelector((s) => s.admin.vendorStats)
	const vendorStatsLoading = useSelector((s) => s.admin.vendorStatsLoading)
	const vendorStatsError = useSelector((s) => s.admin.vendorStatsError)

	const formatVendorCount = (field) => {
		if (vendorStatsLoading && vendorStats == null) return '—'
		if (vendorStatsError && vendorStats == null) return '—'
		return String(vendorStats?.[field] ?? 0)
	}

	return (
		<div className={styles.statCard}>
			<h2 className={styles.statCardTitle}>Vendors</h2>
			<div className={styles.statRow}>
				<p className={styles.statLabel}>Total vendors</p>
				<p className={styles.statValue}>{formatVendorCount('total')}</p>
			</div>
			<div className={styles.statRow}>
				<p className={styles.statLabel}>
					Vendors with accepted proposals for future weddings
				</p>
				<p className={styles.statValue}>
					{formatVendorCount('withAcceptedFutureWeddings')}
				</p>
			</div>
			<div className={styles.statRow}>
				<p className={styles.statLabel}>Vendors with open proposals</p>
				<p className={styles.statValue}>
					{formatVendorCount('withOpenProposals')}
				</p>
			</div>
			{vendorStatsError ? (
				<p className={styles.statsErrorInline}>{vendorStatsError}</p>
			) : null}
		</div>
	)
}
